import axios from 'axios';
// import config from "./config";
import message from './remind';
// import cookie from '@/network/cookie';
import remind from '@/network/remind';

const baseUrl = config.baseUrl;

import router from '../router/index'

//请求超时时间
axios.defaults.timeout = 600000;
// axios.defaults.withCredentials = true;
//请求验证拦截器
let loadingInstance = null;
let reqUrl = null;
axios.interceptors.request.use(config => {
  if (config.url.includes("sendMassageToGpt")) {
    loadingInstance = message.loading("AI助手思考中，请等待15秒左右");
  }else if (config.url.indexOf("getResultBySubmitId") === -1 && config.url.indexOf("aliyuncs") === -1) {
    loadingInstance = message.loading("加载中");
  }
  reqUrl = config.url;
  if (reqUrl.indexOf('downloadTestCaseForZip') > -1 || reqUrl.indexOf('exportDRankScoreInfo') > -1 || reqUrl.indexOf('DownloadAll') > -1 || reqUrl.indexOf('DownloadSelect') > -1) {
    //导出文件
    config.responseType = 'blob';
  }
  console.log(config);
  return config;
}, error => {
  return Promise.error(error);
});

//返回数据拦截器
axios.interceptors.response.use((response) => {
  // loadingInstance.service(remind.loading()).close();
  setTimeout(() => {
    loadingInstance.close()
  }, 200)

  if (reqUrl.indexOf('downloadTestCaseForZip') > -1 || reqUrl.indexOf('exportDRankScoreInfo') > -1 || reqUrl.indexOf('DownloadAll') > -1 || reqUrl.indexOf('DownloadSelect') > -1) {
    //导出文件
    return Promise.resolve(response);
  }
  if (response.data) {
    if (response.data.status === 200) {
      return Promise.resolve(response);
    } else if (response.data.status === -203) {
      remind.message(response.data.info, "warning");
      if (window.location.pathname.indexOf('/teacher') == -1) {
        return router.replace('/login')
      } else {
        return router.replace('/teacher/login')
      }
      sessionStorage.clear()
      return
    } else {
      console.log('error' + response.data.status)
      return Promise.reject({
        status: response.data.status,
        message: response.data.info
      });
    }
  } else {
    return Promise.resolve(response);
  }
}, error => {
  loadingInstance.close()
  return Promise.reject(error.response);
});


//封装请求方法
function formatReq(type, url, data) {
  let token = sessionStorage.getItem('token') || '';
  console.log(token)
  return new Promise((reslove, reject) => {
    axios({
      method: type,
      url: `${baseUrl}${url}`,
      headers: {
        'content-Type': 'application/json',
        'token': token,
        'Authorization': token,
        'imagevercodetoken': sessionStorage.getItem('imageVerCodeToken')
      },
      data: JSON.stringify(data)
    }).then(res => {
      reslove(res);
    }).catch(err => {
      console.log(err);
      if (err.status === -1) {
        remind.message(err.message, "warning");
      } else if (err.status === -201) {
        remind.message(err.message, "warning");
      } else if (err.status === -203) {

      } else {
        remind.message("网络异常，请稍后重试", "error");
      }
      reject(err);
    });
  })
}

const querystring = require("querystring");

////封装请求方法----修改密码的type不同
function othertype(type, url, data) {
  let token = sessionStorage.getItem('token') || '';
  return new Promise((reslove, reject) => {
    axios({
      method: type,
      url: `${baseUrl}${url}`,
      headers: {
        'content-Type': 'application/x-www-form-urlencoded',
        'token': token,
        'Authorization': token,
        'imagevercodetoken': sessionStorage.getItem('imagevercodetoken')
      },
      data: querystring.stringify(data)
    }).then(res => {
      reslove(res);
    }).catch(err => {
      if (err.status === -1) {
        remind.message(err.message, "warning");
      }else if (err.status === -203) {

      } else {
        remind.message("网络异常，请稍后重试", "error");
      }
    });
  })
}

//封装请求方法
function uploadReq(type, url, data) {
  let token = sessionStorage.getItem('token') || '';
  return new Promise((reslove, reject) => {
    axios({
      method: type,
      url: `${baseUrl}${url}`,
      headers: {
        'content-Type': 'multipart/form-data;boundary = ' + new Date().getTime(),
        'token': token,
        'Authorization': token,
        'imagevercodetoken': sessionStorage.getItem('imagevercodetoken')
      },
      data: data
    }).then(res => {
      reslove(res);
    }).catch(err => {
      if (err.status === -1) {
        remind.message(err.message, "warning");
      }else if (err.status === -203) {

      } else {
        remind.message("网络异常，请稍后重试", "error");
      }
    });
  })
}

const Http = {
  get: (url, data) => formatReq('get', url, data),
  post: (url, data) => formatReq('post', url, data),
  put: (url, data) => formatReq('put', url, data),
  patch: (url, data) => formatReq('patch', url, data),
  delete: (url, data) => formatReq('delete', url, data),
  otherpost: (url, data) => othertype('post', url, data),
  postfile: (url, data) => uploadReq('post', url, data),
  root: baseUrl
};

export default Http;



// WEBPACK FOOTER //
// ./src/network/index.js